<template>
  <div class="cmp-wrapper">
    <basic-container>
      <el-form inline :model="formData" ref="billManage">
        <!-- <el-select v-model="selectStore" @change="selectBtn">
          <el-option label="门店ID" value="1"></el-option>
          <el-option label="门店名称" value="2"></el-option>
        </el-select>
        <el-form-item prop="storeId1" v-if="selectStore == 1" style="margin-left:10px;">
          <el-input v-model="storeId1" placeholder="请输入门店ID"></el-input>
        </el-form-item>
        <el-form-item prop="storeId2" v-if="selectStore == 2" style="margin-left:10px;">
          <fuzzy-query
            ref="cusOption2"
            :valueId.sync="storeId2"
            typeKey="storeName"
            :option="cusOption2"
          ></fuzzy-query>
        </el-form-item> -->
        <el-form-item label="城市" prop="cityId">
          <el-select v-model="formData.cityId" filterable placeholder="请选择" style="margin-left: 6px;">
              <el-option
                v-for="item in cityList"
                :key="item.cityId"
                :label="item.name"
                :value="item.cityId">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门店名称" prop="storeId">
          <el-select v-model="formData.storeId" filterable placeholder="请选择" style="margin-left: 6px;width:200px;">
              <el-option
                v-for="item in stores"
                :key="item.code"
                :label="item.storeName"
                :value="item.storeId">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="查询日期">
          <el-date-picker
            v-model="createTime"
            type="daterange"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']"
            style="margin-left:10px;width:500px;"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
        <el-form-item style="width:100%">
          <el-button type="success" @click="exportFile" size="small">导出报表</el-button>
        </el-form-item>
      </el-form>

      <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="">
        <el-tab-pane label="全部订单" name="-1"></el-tab-pane>
        <el-tab-pane label="已提交" name="1"></el-tab-pane>
        <el-tab-pane label="已取消" name="2"></el-tab-pane>
        <el-tab-pane label="已确认" name="3"></el-tab-pane>
        <el-tab-pane label="已完成" name="4"></el-tab-pane>
      </el-tabs> -->

      <el-table v-loading="loading" :data="tableData">
        <el-table-column label="城市" align="center" width="150px" prop="cityName"></el-table-column>
        <el-table-column label="下单日期" align="center" width="150px" prop="tradeCreateTime"></el-table-column>
        <el-table-column label="配送日期" align="center" width="150px" prop="deliveryTime"></el-table-column>
        <el-table-column label="门店ID" align="center" width="100px" prop="buyerUnitId"></el-table-column>
        <el-table-column label="门店名称" align="center" width="120px" prop="buyerUnitName"></el-table-column>
        <el-table-column label="客户名称" align="center" width="100px" prop="customerName"></el-table-column>
        <el-table-column label="下单商品金额" align="center" width="120px" prop="goodsAmount"></el-table-column>
        <el-table-column label="下单包装物金额" align="center" width="100px" prop="packageAmount"></el-table-column>
        <el-table-column label="优惠金额" align="center" width="100px" prop="goodsDiscount"></el-table-column>
        <el-table-column label="下单应收金额" align="center" width="100px" prop="payAmount"></el-table-column>
        <el-table-column label="实收商品金额" align="center" width="100px" prop="receivableAmount"></el-table-column>
        <el-table-column label="实收包装物金额" align="center" width="100px" prop="packageReceiveAmount"></el-table-column>
        <el-table-column label="实收总金额（含税）" align="center" width="100px" prop="settleReceivableAmount"></el-table-column>
        <el-table-column label="实收总金额（无税）" align="center" width="120px" prop="settleReceivableNoTaxAmount"></el-table-column>
        <el-table-column label="税额" align="center" width="100px" prop="taxAmount"></el-table-column>
        <el-table-column label="包装物售后金额" align="center" width="100px" prop="packageReturnAmount"></el-table-column>
        <el-table-column label="商品售后金额" align="center" width="100px" prop="returnAmount"></el-table-column>
        <!-- <el-table-column label="下单时间" align="center" prop="tradeCreateTime" sortable>
          <template slot-scope="scope">
            <span>{{_formatDate(scope.row.tradeCreateTime)}}</span>
          </template>
        </el-table-column> -->
      </el-table>
      <div class="footer pager">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="formData.pageNumber"
          :page-size.sync="formData.pageSize"
          :page-sizes="[20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          :total.sync="total"
          background
        ></el-pagination>
      </div>
    </basic-container>
  </div>
</template>
<script>
import {dateTimeFormatter} from '@/utils/utils.js'
import { getBaseUrl,exportFile } from "@/framework/utils/tools";

export default {
  data() {
    return {
      selectStore:'1',
      storeId1:"",
      storeId2:"",
      createTime:[],
      activeName: '-1',
      cusOption2:[],
      stores:[],
      cityList:[],
      formData: {
        // status: '-1',
        cityId: null,
        startTime: "",
        endTime: "",
        groupName: "",
        storeId: null,
        pageNumber: 1,
        pageSize: 20,
        fromSource: "cs"
      },
      total: 0,
      loading: false,
      tableData: [],
      pickerOptions: {
          disabledDate(time) {
            let cur_time = new Date(new Date().toLocaleDateString()).getTime();
            return time.getTime() > cur_time + 86400000 - 1000;
          },
        },
    };
  },
  created() {
    this.getCitys()
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      const { ret, data } = await _api.bill.getStore();
      if (ret && data && data.length) {
        vm.stores = data;
      } else {
        vm.stores = [];
      }
    })
  },
  watch: {
    "createTime": {
      handler: function(val) {
        if (val) {
          const [start_time, end_time] = val;
          Object.assign(this.formData, { startTime: start_time/1000, endTime: end_time/1000 });
        }else {
          Object.assign(this.formData, { startTime: "", endTime: "" });
        }
      }
    },
    "storeId":{
      handler: function(val) {
        this.formData.storeId = val
      }
    },
    // "storeId2":{
    //   handler: function(val) {
    //     this.formData.storeId = val
    //   }
    // },
    "status":{
      handler: function(val) {
        this.formData.status = val
      }
    },
    "orderId":{
      handler: function(val) {
        this.formData.orderId = val
      }
    }
  },
  methods: {
    selectBtn(val){
      this.formData.storeId = this.storeId1
      if(val == "2"){
        this.formData.storeId = this.storeId2
      }
    },
    // toDetail(row){
    //   if(row){
    //     this.$router.push({
    //       path: "/orderManagement/detail",
    //       query: {
    //         storeId:row.storeId,
    //         orderId:row.orderId
    //       }
    //     });
    //   }
    // },
    _formatDate (ct) {
      return ct ? dateTimeFormatter(ct*1000, 'YYYY-MM-DD HH:mm:ss') : '--'
    },
    handleClick(tab, event) {
      // this.formData.status = this.activeName
      this.search()
    },
    search() {
      // if(!this.formData.storeId){
      //   this.$message({
      //     type: "warning",
      //     message: "请选择门店"
      //   });
      //   return;
      // }
      this.formData.pageNumber = 1;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const {
        ret,
        data: { list, totalCount }
      } = await _api.bill.getList(this.formData);
      if (ret && list) {
        this.tableData = list || [];
        this.total = totalCount;
      }
      this.loading = false;
    },

    async getCitys () {
      const res = await _api.bill.getBizCitys({
        type: 1, // 1 则是美菜城市
        // status: 1 // 1开通 不传或者null 取所有
      })
      if (!res || !res.ret || !res.data) {
        this.cityList = []
        return
      }
      this.cityList = res.data || []
    },
    // 重置
    reset() {
      this.formData.storeId = ""
      if(this.$refs["cusOption"]){
        this.$refs["cusOption"].reset()
      }
      this.$refs["billManage"].resetFields();
      this.createTime = []
    },
    handleCurrentChange(val) {
      this.getList();
    },
    handleSizeChange(val) {
      this.formData.pageNumber = 1;
      this.getList();
    },
    //导出
    async exportFile() {
      // if (this.total > 5000) {
      //   this.$message({
      //     type: "warning",
      //     message: "导出数据需≤5000条，请减少导出量"
      //   });
      //   return;
      // }
      // this.$message({
      //   type: "warning",
      //   message: "正在导出，请稍后"
      // });
      this.loading=true;
      const {
        ret,
        data
      } = await _api.bill.export(this.formData);
        
      this.loading=false;

      if(ret){
        this.$message({
          type:"warning",
          message: data
        })
      }

      //exportFile(`${getBaseUrl()}/dmall-manage/dmallmanage/order/export`,this.formData,'订单数据.xlsx')
    },
  }
};
</script>
<style>
.img li{ 
  float:left;
  margin-left:5px; 
  list-style-type:none;
}
</style>